var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "edit_frame" },
    [
      _c("common_edit", { attrs: { multiple: _vm.multiple } }),
      _vm.module.textType === "positionInfo"
        ? [
            _c("div", { staticClass: "title" }, [_vm._v(" 职位信息 ")]),
            _c(
              "div",
              { staticClass: "position" },
              [
                _c(
                  "el-checkbox-group",
                  {
                    attrs: { direction: "horizontal" },
                    on: { change: _vm.handlePositionInfoChange },
                    model: {
                      value: _vm.module.positionInfoList,
                      callback: function ($$v) {
                        _vm.$set(_vm.module, "positionInfoList", $$v)
                      },
                      expression: "module.positionInfoList",
                    },
                  },
                  _vm._l(_vm.positionList, function (item) {
                    return _c(
                      "el-checkbox",
                      { key: item.label, attrs: { label: item.label } },
                      [_vm._v(_vm._s(item.label))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c("div", { staticClass: "title" }, [_vm._v(" 样式 ")]),
      _c(
        "div",
        { staticClass: "text-content" },
        [
          _vm.module.isEditing
            ? [
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      effect: "dark",
                      content: "颜色",
                      placement: "top",
                    },
                  },
                  [
                    !_vm.isPlainStroke
                      ? _c("my_color", {
                          ref: "colorPicker",
                          attrs: { color: _vm.color },
                          on: {
                            change: _vm.on_color_change,
                            "update:color": function ($event) {
                              _vm.color = $event
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      effect: "dark",
                      content: "颜色",
                      placement: "top",
                    },
                  },
                  [
                    !_vm.isPlainStroke
                      ? _c("my_color", {
                          ref: "colorPicker",
                          attrs: { color: _vm.module.style.color },
                          on: {
                            "update:color": function ($event) {
                              return _vm.$set(_vm.module.style, "color", $event)
                            },
                            change: _vm.on_color_change,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
          _c("my_text_align", {
            staticClass: "bottom flexbox sel_align",
            attrs: { value: _vm.module.style["text-align"] },
            on: {
              "update:value": function ($event) {
                return _vm.$set(_vm.module.style, "text-align", $event)
              },
              changeTextAlign: _vm.on_text_align_change,
            },
          }),
          _c("my_font_style", {
            staticClass: "flexbox sel_style",
            on: {
              changeFontWeight: _vm.on_font_weight_change,
              changeFontStyle: _vm.on_font_style_change,
              changeTextDecoration: _vm.on_text_decoration_change,
              changeWritingMode: _vm.on_writing_mode_change,
            },
          }),
        ],
        2
      ),
      _c("div", { staticClass: "title" }, [_vm._v(" 文字 ")]),
      _c("section", { staticClass: "text-content" }, [
        _c(
          "div",
          { staticClass: "flexbox sel_powerover" },
          [
            _vm.module.isEditing
              ? [
                  _c("my_font_family", {
                    staticClass: "sel_family",
                    attrs: {
                      title: "字体",
                      size: "small",
                      value: _vm.font_family,
                    },
                    on: { change: _vm.on_font_family_change },
                  }),
                ]
              : [
                  _c("my_font_family", {
                    staticClass: "sel_family",
                    attrs: {
                      title: "字体",
                      size: "small",
                      value: _vm.module.style["font-family"],
                    },
                    on: {
                      "update:value": function ($event) {
                        return _vm.$set(_vm.module.style, "font-family", $event)
                      },
                      change: _vm.on_font_family_change,
                    },
                  }),
                ],
            _vm.module.isEditing
              ? [
                  _c("my_font_size_new", {
                    attrs: { title: "字号", value: _vm.font_size },
                    on: {
                      "update:value": function ($event) {
                        _vm.font_size = $event
                      },
                      change: _vm.on_change_font_size,
                    },
                  }),
                ]
              : [
                  _c("my_font_size_new", {
                    attrs: {
                      title: "字号",
                      value: _vm.module.style["font-size"],
                    },
                    on: {
                      "update:value": function ($event) {
                        return _vm.$set(_vm.module.style, "font-size", $event)
                      },
                      change: _vm.on_change_font_size,
                    },
                  }),
                ],
          ],
          2
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }